const form = {
  formId: "new-user-form",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label: "HKD, CNKD nộp thuế theo phương pháp khoán",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "CNKD nộp thuế theo từng lần phát sinh",
      type: "text",
    },
    checkbox3: {
      name: "checkbox3",
      label: "Tổ chức, cá nhân khai thuế thay, nộp thuế thay",
      type: "text",
    },
    checkbox4: {
      name: "checkbox4",
      label: "HKD, CNKD nộp thuế theo phương pháp kê khai",
      type: "text",
    },
    checkbox5: {
      name: "checkbox5",
      label:
        "HKD, CNKD trong lĩnh vực ngành nghề có căn cứ xác định được doanh thu theo xác nhận của cơ quan chức năng",
      type: "text",
    },
    checkbox6: {
      name: "checkbox6",
      label: "Hộ khoán chuyển đổi phương pháp tính thuế",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    field01a: {
      name: "field01a",
      label: "[01a] Năm",
      type: "number",
      placeholder: "2023",
      errorMsg: "Vui lòng nhập năm",
    },
    field01b: {
      name: "field01b",
      label: "[01b] Kỳ thanh toán",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01c: {
      name: "field01c",
      label: "[01c] Tháng / năm",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01d: {
      name: "field01d",
      label: "[01d] Từ tháng / Đến tháng",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
